export { BeeConfirmDeleteComponent } from './bee-confirm-delete.component';
export { BeeConfirmDeleteModule } from './bee-confirm-delete.module';
